import React, { useEffect } from 'react';
import { versionChecker } from '../utils/versionCheck';

/**
 * Auto-refresh version checker component
 * Automatically refreshes the app when a new version is detected
 * No UI - just handles version checking in the background
 */
const AutoVersionChecker: React.FC = () => {
  useEffect(() => {
    // Start version checking when component mounts
    console.log('🔔 Auto-refresh version checker: Starting');

    // Debug: Check current version immediately
    const metaTag = document.querySelector('meta[data-version]');
    const currentVersion = metaTag?.getAttribute('data-version');
    console.log('🔍 Current version from meta tag:', currentVersion);

    // Start version checking without callback - will auto-refresh when new version detected
    versionChecker.startVersionCheck();

    // Cleanup on unmount
    return () => {
      console.log('🔔 Auto-refresh version checker: Stopping');
      versionChecker.stopVersionCheck();
    };
  }, []);

  // No UI - just background version checking
  return null;
};

export default AutoVersionChecker;
